import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
// import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

import Search from "components/inputs/Search";
import Select from "components/inputs/Select";
// import Loading from "components/App/Loading";
import Card from "./CustomProductCard";

function mergeArrayObjects(arr1, arr2) {
  return arr1.map((item1, index1) => {
    let foundIndex = arr2.findIndex(
      (item2, index2) => item2.title === item1.title
    );
    return foundIndex > -1
      ? { ...item1, amount: arr2[foundIndex].amount }
      : item1;
  });
}

export default function App({
  reload,
  setReload,
  products,
  list,
  setList,
  info,
}) {
  const [form] = Form.useForm();

  const [mergedProducts, setMergedProducts] = React.useState(
    list.length ? mergeArrayObjects(products, list) : products
  );
  const [data, setData] = React.useState(mergedProducts);
  const [brand, setBrand] = React.useState("همه");
  const [category, setCategory] = React.useState("همه");

  React.useEffect(() => {
    setReload(false);
  }, [list.length, list, reload, setReload]);
  React.useEffect(() => {
    setMergedProducts(
      list.length ? mergeArrayObjects(products, list) : products
    );
  }, [products, list, products.length, list.length]);

  // apply filters on change :::
  React.useEffect(() => {
    var newProducts = mergedProducts;

    if (category !== "همه") {
      newProducts = newProducts.filter((item) => item.category === category);
    }
    if (brand !== "همه") {
      newProducts = newProducts.filter((item) => item.brand === brand);
    }
    setData(newProducts);
  }, [brand, category, mergedProducts]);
  console.log("render");

  function onSubmit({ title, amount, description, price }) {
    let foundIndex = list.findIndex((x) => x.title === title);
    if (amount) {
      console.log(foundIndex);
      if (foundIndex > -1) {
        setList((e) => {
          let newList = e;
          newList[foundIndex] = {
            title,
            amount,
            description,
            price,
          };

          return newList;
        });
        return false;
      } else {
        setList((e) => [...e, { title, amount, description, price }]);
      }
    } else {
      // message.error("لطفا نام کالای مورد نظر را انتخاب ");

      // handle delete check
      if (foundIndex > -1 && Number(amount) === 0) {
        deleteItem(foundIndex);
        return false;
      }
    }
  }

  function deleteItem(index) {
    var newList = list;
    newList.splice(index, 1);
    setReload(true);
    setList(newList);
    message.success("با موفقیت حذف شد");
  }
  function handleSearch({ target }) {
    const { value } = target;
    var newProducts = mergedProducts;
    if (value) {
      newProducts = newProducts.filter(
        (item) => item.title.includes(value) && item
      );
    }
    setData(newProducts);
  }

  return (
    <>
      <Search
        placeholder="جستجو..."
        onChange={handleSearch}
        style={{ marginBottom: 20, marginTop: -10, borderRadius: 6 }}
      />
      <FilterContainer>
        <Select
          title="دسته بندی"
          list={[{ title: "همه" }, ...info.categories]}
          style={{ marginRight: 16 }}
          showSearch
          placeholder="جستجو"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
          onChange={(value) => setCategory(value)}
        />
        <Select
          title="برند"
          list={[{ title: "همه" }, ...info.brands]}
          style={{ marginRight: 16 }}
          showSearch
          placeholder="جستجو"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
          onChange={(value) => setBrand(value)}
        />
      </FilterContainer>
      <Container>
        {data.map((item, key) => (
          <Card data={item} handleSubmit={onSubmit} key={key} />
        ))}
      </Container>
    </>
  );
}
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  align-content: flex-end;
`;
const FilterContainer = styled.div`
  display: flex;
`;
